module.exports = __webpack_public_path__ + "img/OZ.0871a1eb.png";